import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            热门分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {categories.filter(c => c !== '全部').map((cat) => (
            <Link
              key={cat}
              to={`/category/${cat}`}
              className="px-5 py-2.5 bg-background-100 hover:bg-primary-500 hover:text-background-50 text-foreground-700 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {cat}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}